//src/pages/matching-intergenerationnel/QuestionnaireRedirect.tsx
import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { VISION_URL } from "@/config/domains";

const VISION_BASE = VISION_URL;

export default function QuestionnaireRedirect() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";

  useEffect(() => {
    const url = `${VISION_BASE}/matching-intergenerationnel/questionnaire?token=${encodeURIComponent(token)}`;
    window.location.replace(url);
  }, [token]);

  return null;
}

